module.exports = __webpack_public_path__ + "img/zixun_1.e3778dc.png";